import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';
import { Columns } from '@components/Columns';
import { Box, BoxProps } from '@components/Box';
import { Text } from '@components/typography';

import { StyledLink, StyledShowMoreButton } from './PressMentionsSection.styles';

interface PressNodeType
  extends Readonly<{
    pressImg: string;
    title: string;
    subtitle: string;
    link: string;
  }> {}

interface PressMentionsProps {
  pressNodes: ReadonlyArray<PressNodeType>;
  backgroundColor: BoxProps['backgroundColor'];
}

export const PressMentionsSection: React.FC<PressMentionsProps> = ({ pressNodes, backgroundColor }) => {
  const [numItemsShown, setNumItemsShown] = useState(6);

  const showMore = () => {
    const nextNumItemsToShow = numItemsShown + 3;
    if (numItemsShown === pressNodes.length) {
      setNumItemsShown(6);
    } else if (nextNumItemsToShow < pressNodes.length) {
      setNumItemsShown(nextNumItemsToShow);
    } else {
      setNumItemsShown(pressNodes.length);
    }
  };

  return (
    <Box backgroundColor={backgroundColor} paddingY={[0, 10, 12]} paddingX={[5, 5, 11]} id="featured-coverage">
      {pressNodes.slice(0, numItemsShown).map(node => (
        <Box
          key={node.title}
          paddingY={10}
          style={{
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          }}
        >
          <Columns centered={true}>
            <Columns.Column width="one-third">
              <Box marginBottom={[10, 10, 0]} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <CloudImage style={{ maxWidth: '328px' }} src={node.pressImg} alt="" />
              </Box>
            </Columns.Column>
            <Columns.Column width="two-thirds">
              <Box
                marginX={[0, 5, 7]}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height: '100%' }}
              >
                <TextPairing
                  key={node.title}
                  title={ReactHtmlParser(node.title)}
                  titleVariant="dek24"
                  titleColor="purple6"
                  titleTagName="h3"
                  body={ReactHtmlParser(node.subtitle)}
                  bodyVariant="featureCopy17"
                  bodyColor="purple6"
                  bodyTagName="h4"
                  alignment="left"
                />
                <StyledLink href={node.link} aria-label={node.link} target="_blank">
                  <Text tagName="span" variant="featureCopy17">
                    Read More
                  </Text>
                </StyledLink>
              </Box>
            </Columns.Column>
          </Columns>
        </Box>
      ))}
      <StyledShowMoreButton onClick={showMore} aria-label="View more news">
        <Text tagName={'p'} variant={'featureCopy17'}>
          {numItemsShown === pressNodes.length ? 'View less' : 'View more'}
        </Text>
      </StyledShowMoreButton>
    </Box>
  );
};
